import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../../components/HOC/injectRole'

import { TRoutes } from '../../../shared/const'
import { mayOpenAdminPage } from '../../../shared/alumni'
import Users from '../../../components/views/admin/Users'

function UsersPage(props) {
	if (mayOpenAdminPage(props.role, 'users')) return <Users />
	else return <Redirect to={TRoutes.DASHBOARD} />
}

UsersPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(UsersPage)
